import React, { useState } from 'react';
import { usePharmacies } from '../context/PharmacyContext';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuCheckboxItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Building2, ChevronDown } from 'lucide-react';

function PharmacySelector() {
  const {
    userPharmacies,
    selectedPharmacyIds,
    togglePharmacy,
    getSelectedPharmaciesNames
  } = usePharmacies();

  const [open, setOpen] = useState(false);

  if (!userPharmacies || userPharmacies.length === 0) {
    return null;
  }

  // If user has only one pharmacy, don't show selector
  if (userPharmacies.length === 1) {
    return (
      <div className="flex items-center gap-2 px-3 py-2 bg-green-50 rounded-lg border border-green-200">
        <Building2 className="w-4 h-4 text-green-600" />
        <span className="text-sm font-medium text-green-700">
          {userPharmacies[0].pharmacy_name}
        </span>
      </div>
    );
  }

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          className="justify-between min-w-[200px] max-w-[300px] border-green-200 hover:border-green-300 hover:bg-green-50"
        >
          <div className="flex items-center gap-2 truncate">
            <Building2 className="w-4 h-4 text-green-600 flex-shrink-0" />
            <span className="text-sm truncate">{getSelectedPharmaciesNames()}</span>
          </div>
          <ChevronDown className="w-4 h-4 ml-2 flex-shrink-0" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[300px]">
        <DropdownMenuLabel>Sélectionner Pharmacie(s)</DropdownMenuLabel>
        <DropdownMenuSeparator />
        
        <DropdownMenuCheckboxItem
          checked={selectedPharmacyIds.includes('all')}
          onCheckedChange={() => togglePharmacy('all')}
          className="font-semibold"
        >
          <Building2 className="w-4 h-4 mr-2" />
          Toutes mes pharmacies ({userPharmacies.length})
        </DropdownMenuCheckboxItem>
        
        <DropdownMenuSeparator />
        
        {userPharmacies.map((pharmacy) => (
          <DropdownMenuCheckboxItem
            key={pharmacy.pharmacy_id}
            checked={
              !selectedPharmacyIds.includes('all') &&
              selectedPharmacyIds.includes(pharmacy.pharmacy_id)
            }
            onCheckedChange={() => togglePharmacy(pharmacy.pharmacy_id)}
          >
            <div className="flex flex-col items-start">
              <span className="font-medium">{pharmacy.pharmacy_name}</span>
              <span className="text-xs text-gray-500 capitalize">{pharmacy.role}</span>
            </div>
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default PharmacySelector;
